// Types
import { IJourney } from '@src/common/types/journey';
import { FrequencyCapping } from '@src/common/types/frequencyCapping';

export const defineFrequencyCapping = (journey: IJourney): FrequencyCapping => ({
  isEnabled: journey?.params?.frequencyCapping?.isEnabled || false,
  period: journey?.params?.frequencyCapping?.period || 0
});
